import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/down.png'


const _withScopeId = n => (_pushScopeId("data-v-cd190352"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "media-item-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "file-name text-overflow-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Download"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "icon-down"
  })
], -1))

import { computed, onMounted } from 'vue';
  import mime from 'mime';
  import download from 'downloadjs';

  export interface Media {
    url: string;
    contentType: string;
    filename: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    url: null,
    contentType: null,
    filename: null
  },
  setup(__props: any) {

const props = __props as {
    url: string;
    contentType: string;
    filename: string;
  }

  

  const cover = computed(() => {
    // TODO: 等待添加默认类型和更多类型

    return {
      '7z': require('@/assets/media-type-icons/7z.png'),
      csv: require('@/assets/media-type-icons/csv.png'),
      doc: require('@/assets/media-type-icons/doc.png'),
      docx: require('@/assets/media-type-icons/docx.png'),
      pdf: require('@/assets/media-type-icons/pdf.png'),
      ppt: require('@/assets/media-type-icons/ppt.png'),
      pptx: require('@/assets/media-type-icons/pptx.png'),
      rar: require('@/assets/media-type-icons/rar.png'),
      tar: require('@/assets/media-type-icons/tar.png'),
      txt: require('@/assets/media-type-icons/txt.png'),
      xls: require('@/assets/media-type-icons/xls.png'),
      xlsx: require('@/assets/media-type-icons/xlsx.png'),
      zip: require('@/assets/media-type-icons/zip.png'),
      image: props.url,
    }[mime.getExtension(props.contentType) as string];
  });

  onMounted(() => {});

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(cover),
      class: "image"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(props.filename), 1),
      _createVNode(_component_b_button, {
        pill: "",
        variant: "outline-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(download)(__props.url, __props.filename)))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ]))
}
}

})